// Pantallas a las que entra un despacho colaborador (docs/partners-plan.md):
// Reclamaciones, el expediente, Tareas y su propio perfil. Es el reflejo en el
// front de la lista blanca del backend (apps/backend/policies/partner-routes.js),
// que es la que protege de verdad: esto solo evita pantallas que darían 403.
import { isPartnerRole } from '@claimup/shared/constants/roles';

const PARTNER_PAGES = [/^\/expedients\/?$/, /^\/view\/[^/]+\/?$/, /^\/tasks\/?$/];

// Rutas públicas o de sesión: se dejan pasar siempre.
const PUBLIC_PAGES = [/^\/login/, /^\/registro/, /^\/forgot-password/, /^\/reset-password/, /^\/privacy-policy/];

export const PARTNER_HOME = '/expedients';

/** ¿Puede este usuario abrir esta ruta del front? Otros roles: siempre. */
export function isPartnerPageAllowed(user, pathname) {
  if (!isPartnerRole(user?.role)) return true;
  if (PUBLIC_PAGES.some(re => re.test(pathname))) return true;
  if (PARTNER_PAGES.some(re => re.test(pathname))) return true;
  // Solo su propio perfil.
  return !!user?.id && pathname.replace(/\/$/, '') === `/profile/${user.id}`;
}
